import { render } from "./Navbar.vue?vue&type=template&id=398c3928"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=398c3928&lang=scss"
script.render = render

export default script